import { FREE_DURING_ALPHA, NO_REAL_MONEY } from '@tv-casino/viewmodels/lib/playMoney.js';
import { buildLabel } from '../lib/build.js';
import styles from './AlphaNotice.module.css';

/**
 * The small "Alpha" pill that rides beside a page title. Hidden from screen
 * readers so the heading keeps its own name; the build stamp says "alpha" in
 * words where it matters.
 */
export function AlphaBadge({ className }: { className?: string }) {
  return (
    <span
      className={className ? `${styles.badge} ${className}` : styles.badge}
      title="TV Casino is in alpha"
      aria-hidden="true"
      data-alpha-badge=""
    >
      Alpha
    </span>
  );
}

/** The build a screen is running, in quiet small print. */
export function BuildStamp({ className }: { className?: string }) {
  return (
    <p className={className ? `${styles.stamp} ${className}` : styles.stamp} data-build-stamp="">
      Build {buildLabel()}
    </p>
  );
}

// The copy is shared with the phone app, so both say the same thing.
export { FREE_DURING_ALPHA, NO_REAL_MONEY };

/** "Free during alpha" as a gold ribbon, for the doors people come in by. */
export function FreeDuringAlpha({ className }: { className?: string }) {
  return (
    <p className={className ? `${styles.free} ${className}` : styles.free}>{FREE_DURING_ALPHA}</p>
  );
}

/**
 * The small print under a door: play money only, then the build. `free`
 * adds the alpha pricing line on the pages that sell the night.
 */
export function PlayForFun({ free = false, className }: { free?: boolean; className?: string }) {
  return (
    <div
      className={className ? `${styles.fine} ${className}` : styles.fine}
      role="note"
      aria-label="About this game"
    >
      {free && <FreeDuringAlpha />}
      <p className={styles.legal}>{NO_REAL_MONEY}</p>
      <BuildStamp />
    </div>
  );
}
